"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
var moment = require("moment");
var formatDate = function (date) {
    if (!date) {
        return;
    }
    return moment(date).format('YYYY-MM-DD HH:mm');
};
exports.formatDate = formatDate;
